import {Segmentation} from 'common/types/reports/query';
import {
  DURATION_UNIT_OPTION_SECTION_ITEMS,
  FUNNELS_TIME_TO_CONVERSION,
  PAGE_DURATION,
} from 'common/query-builder/query-block/properties-menu/constants';
import {SPECIAL_EVENTS} from 'common/report/constants';
import {Bucket} from 'common/widgets/bucket-pane/types';

import {DefaultCustomBucket, DefaultCustomTCCBucket} from '../constants';
import {isSegmentEntry, QueryBucketableEntry} from '../types';
import {isMultiAttributionSegmentation} from '../row-types/behavior/utils';

export type CustomBucketAttributes = {
  eventNames: string[];
  units?: string[] | Array<{value: string; label: string}>;
  selectedBucket: Bucket;
  selectedUnit: string;
  resetBucket: boolean;
  maxNumBuckets: number;
  unitsAsProperty: boolean;
};

export function getCustomBucketAttributes({
  entry,
  eventNames,
  defaultBucket,
}: {
  entry: QueryBucketableEntry;
  eventNames: string[];
  defaultBucket?: Bucket;
}): CustomBucketAttributes {
  const getDefaultBucket = (isTimeToConvert: boolean) => {
    if (isTimeToConvert) {
      return DefaultCustomTCCBucket;
    } else if (defaultBucket) {
      return defaultBucket;
    }
    return DefaultCustomBucket;
  };

  const bucket = entry?.customBucket;

  const customGroups = isSegmentEntry(entry) && (entry.event as Segmentation).customGroups;
  const isMultiAttribution = isSegmentEntry(entry) && isMultiAttributionSegmentation(entry.event);
  const isTimeToConvert =
    isSegmentEntry(entry) &&
    ((entry.event as Segmentation).propertyName === FUNNELS_TIME_TO_CONVERSION.value ||
      (entry.event as Segmentation).propertyName === PAGE_DURATION.value);
  const selectedBucket = bucket || getDefaultBucket(isTimeToConvert);
  const units = isTimeToConvert ? DURATION_UNIT_OPTION_SECTION_ITEMS : undefined;
  const selectedUnit = isTimeToConvert ? selectedBucket.unit ?? `day` : `units`; //TODO - convert selected to display

  return {
    // Multi attribution properties can come from potentially all event
    eventNames: isMultiAttribution ? [...eventNames, SPECIAL_EVENTS.ALL_EVENTS] : eventNames,
    maxNumBuckets: 1000,
    resetBucket: !!bucket || !!customGroups,
    selectedBucket,
    selectedUnit,
    units,
    unitsAsProperty: isTimeToConvert,
  };
}
